import {IActionContext} from "../create_path_to_action";
import {setAuthAndDate} from "./common_action";

export const pressOfficeAction = async (ctx: IActionContext<{}>): Promise<void> => {
    await setAuthAndDate(ctx);
};
